exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#loading{display:none;position:fixed;z-index:10;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.2)}#loading img{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100px}#loading.active{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c89e465","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Loading.vue
// module id = 388
// module chunks = 0